import PropTypes from 'prop-types';
import React from 'react';
import { actionOnKeyboardPress } from '../utils/browserUtils';

const getSelectedClass = (selectedId, optionId) => `${selectedId === optionId ? ' selected' : ''}`;

const ResponseBox = props => (
    <ul className="daze-menu">
        {props.options.map(option => (
            <li value={option.id} key={`${props.questionId}-${option.id}`}>
                <span
                    aria-label={option.text}
                    aria-pressed={props.selectedId === option.id}
                    tabIndex={props.isTabIndexActive ? 0 : '-1'}
                    role="button"
                    className={`daze-option${getSelectedClass(props.selectedId, option.id)}`}
                    data-dd-action-name={option.text}
                    onKeyDown={e =>
                        actionOnKeyboardPress(e, () =>
                            props.onResponseSelected(props.questionId, option.id),
                        )
                    }
                    onClick={() => {
                        props.onResponseSelected(props.questionId, option.id);
                    }}
                >
                    {option.text}
                </span>
            </li>
        ))}
    </ul>
);

export default ResponseBox;

ResponseBox.propTypes = {
    options: PropTypes.array,
    questionId: PropTypes.string,
    selectedId: PropTypes.number,
    onResponseSelected: PropTypes.func,
    isTabIndexActive: PropTypes.bool.isRequired,
};

ResponseBox.defaultProps = {
    options: [],
    questionId: undefined,
    selectedId: undefined,
    onResponseSelected: () => {},
};
